/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Next1Inputs */

const vi_cmspost_next1 = /** @type {(inputs: Cmspost_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang sau`)
};

/**

* @param {Cmspost_Next1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_next1 = /** @type {((inputs?: Cmspost_Next1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Next1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_next1(inputs)
});
export { cmspost_next1 as "cmsPost_next" }